<template>
    <div>
        <BackgroundTitle heading="2" sub="TIN TỨC">
            Tin hot công nghệ hôm nay
        </BackgroundTitle>
        <div class="py-5">
            <div class="container">
                <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
                <div class="article">
                    <div class="row">
                        <div class="col-lg-9 mb-3">
                            <h1 class="article-title">
                                {{ article.title }}
                            </h1>
                            <p class="article-date">
                                {{ article.createdDate | moment('DD/MM/YYYY') }}
                            </p>
                            <div
                                class="article-content"
                                v-html="article.content"
                            ></div>
                            <div class="article-share">
                                <span class="mr-3">Chia sẻ:</span>
                                <a
                                    href="#"
                                    class="
                                        btn btn-circle btn-white-smoke
                                        text-black
                                        p-0
                                        w-40-px
                                        h-40-px
                                        line-height-40-px
                                        mx-1
                                    "
                                >
                                    <i class="fab fa-twitter"></i>
                                </a>
                                <a
                                    href="#"
                                    class="
                                        btn btn-circle btn-white-smoke
                                        text-black
                                        p-0
                                        w-40-px
                                        h-40-px
                                        line-height-40-px
                                        mx-1
                                    "
                                >
                                    <i class="fab fa-facebook-f"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <h5 class="font-weight-bold mb-4">Tin liên quan</h5>
                            <ArticleItemSimple
                                v-for="(item, index) in relatedArticles"
                                :key="index"
                                :data="item"
                            ></ArticleItemSimple>
                        </div>
                    </div>
                </div>
                <div class="article-related">
                    <h2 class="article-title">Tin hot</h2>
                    <swiper ref="hotArticles" :options="hotArticlesOptions">
                        <swiper-slide
                            v-for="(item, index) in hotArticles"
                            :key="index"
                            class="h-auto"
                        >
                            <ArticleItem :data="item"></ArticleItem>
                        </swiper-slide>
                    </swiper>
                    <div class="d-flex justify-content-center mt-3">
                        <div
                            class="nav-button"
                            slot="button-prev"
                            @click="prevRelated"
                        >
                            <i class="far fa-angle-left"></i>
                        </div>
                        <div
                            class="nav-button"
                            slot="button-next"
                            @click="nextRelated"
                        >
                            <i class="far fa-angle-right"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BackgroundTitle from '@/components/utils/BackgroundTitle/BackgroundTitle';
import { getArticleDetail } from '@/services/article.service';
import SwiperClass, { Navigation } from 'swiper';
SwiperClass.use([Navigation]);
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
import ArticleItem from '@/components/ArticleItem/ArticleItem';
import ArticleItemSimple from '@/components/ArticleItemSimple/ArticleItemSimple';

export default {
    name: 'ArticleDetail',
    components: {
        ArticleItemSimple,
        ArticleItem,
        BackgroundTitle,
        Swiper,
        SwiperSlide,
    },
    directives: {
        swiper: directive,
    },
    data() {
        return {
            breadcrumbs: [
                {
                    text: 'Trang chủ',
                    href: '/',
                },
                {
                    text: 'Tin tức',
                    href: '/tin-tuc',
                },
            ],
            article: {},
            relatedArticles: [],
            hotArticles: [],
            hotArticlesOptions: {
                slidesPerView: 1,
                spaceBetween: 16,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                loop: true,
                pagination: {
                    el: '#banner-pagination',
                    clickable: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                    },
                    640: {
                        slidesPerView: 2,
                    },
                    320: {
                        slidesPerView: 1,
                    },
                },
            },
        };
    },
    watch: {
        $route: {
            immediate: true,
            async handler() {
                this.breadcrumbs = [
                    {
                        text: 'Trang chủ',
                        href: '/',
                    },
                    {
                        text: 'Tin tức',
                        href: '/tin-tuc',
                    },
                ];
                await this.fetchData();
                this.breadcrumbs.push({
                    text: this.article.title,
                    active: true,
                });
            },
        },
    },
    methods: {
        async fetchData() {
            const slug = this.$route.params.slug;
            const { data } = await getArticleDetail(slug);
            if (!data.article) {
                this.$router
                    .push({
                        name: 'not-found',
                    })
                    .catch(() => {});
                return;
            }
            this.article = data.article;
            this.relatedArticles = data.relatedArticles;
            this.hotArticles = data.hotArticles;
        },
        prevRelated() {
            this.$refs.hotArticles.$swiper.slidePrev();
        },
        nextRelated() {
            this.$refs.hotArticles.$swiper.slideNext();
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'ArticleDetail';
</style>
